module.exports = __webpack_public_path__ + "img/oven mitts.d07d16cc.svg";